import React from 'react';

const App = () => (
  <div className="app">
    <>Hello World!</>
  </div>
);

export default App;
